/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

enum ChannelState {
  Initializing = 0,
  Offline = 1,
  Starting = 2,
  Paused = 3,
  Playing = 4,
  Recovering = 5,
  Reconnecting = 6,
  StandBy = 7,
  Stopped = 8,
  Unauthorized = 9,
  GeoRestricted = 10,
  GeoBlocked = 11,
  UnsupportedFeature = 12,
  ConfigurationError = 13,
  TransientConfigurationError = 14,
  ConnectionError = 15,
  ClientStartError = 16,
  Error = 17
}

export default ChannelState;